<template>
  <div @click="$event.stopPropagation();">
    <b-form-group>
      <b-form-input
          class="chip-search-input"
          placeholder="Buscar identificadores"
          v-model="searchText"
          />
    </b-form-group>
    <p class="chip-group">
      <span
        v-for="option in filteredOptions"
        :key="option.label"
        :class="{ active: isActive(option) }"
        class="chip-group__item badge badge-secondary pointer"
        @click="setSelectedOption(option)"
        >
        {{ option.label }}
        <span  class="chip-group__item__remove"
          @click="removeOption(option)"></span>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Chips',
  props: {
    value: {},
    options: {
      required: true,
      type: Array,
      validator(options) {
        return options.every(option => Object.prototype.hasOwnProperty.call(option, 'label')
          && Object.prototype.hasOwnProperty.call(option, 'value'));
      },
    },
  },
  data() {
    return {
      optionsCopy: [],
      selectedOptions: [],
      searchText: null,
    };
  },
  computed: {
    filteredOptions() {
      if (!this.searchText) return this.optionsCopy;
      return this.optionsCopy.filter(option => option.label.match(this.searchText));
    },
    selectedValues() {
      if (!this.selectedOptions) return null;
      return this.selectedOptions.map(option => option.value);
    },
  },
  methods: {
    isActive(option) {
      return this.selectedOptions.includes(option);
    },
    setSelectedByValue(value) {
      if (typeof value !== 'undefined') {
        const selectedOption = this.optionsCopy.find(option => value.includes(option.value));
        this.setSelectedOption(selectedOption, false);
      }
    },
    setSelectedOption(option, emmit = true) {
      if (option) {
        this.selectedOptions = [option];
        if (emmit) this.$emit('input', this.selectedValues);
      }
    },
    removeOption(option) {
      const index = this.optionsCopy.indexOf(option);
      if (index > -1) {
        this.optionsCopy.splice(index, 1);
      }
      this.$emit('chipRemoved', option);
    },
  },
  beforeMount() {
    this.optionsCopy = [...this.options];
    this.setSelectedByValue(this.value);
  },
  watch: {
    options: {
      handler() {
        this.optionsCopy = [...this.options];
      },
    },
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) this.setSelectedByValue(newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.chip-group {
  margin-left: -2px;
  margin-right: -2px;
  max-height: 6.2em;
  font-size: 14px;
  font-weight: normal;
  overflow-y: auto;
}
.chip-group__item {
  max-width: 100%;
  overflow: hidden;
  background-color: #D9D9D9;
  color: $mine-shaft;
  margin: 2px;
  padding: 6px;
  display: inline-flex;
  align-items: center;

  &.active {
    background-color: $orange;
    color: $text-light;
  }
}
.chip-group__item__remove {
  display: inline-block;
  width: 13px;
  height: 13px;
  background: url('~@/assets/images/garbage.svg') center center no-repeat;
  background-size: contain;
  margin-left: 5px;
}

.active .chip-group__item__remove {
  background-image: url('~@/assets/images/garbage-active.svg');
}

.chip-search-input {
  border-radius:0;
  background-image: url('~@/assets/glass.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  padding-left: 45px;
}
</style>
